import { ColumnProperty, CustomTableRowChildProps } from "../types";
import _ from "lodash";

import { useMemo } from "react";

import React from "react";
import TableHeader from "./TableHeader";

const TableRowChild: React.FC<CustomTableRowChildProps> = (props) => {
  const { rows, columns, onRowClick, CustomTableRowChild, show, parentColumnsCount, childTableTitle } = props;

  const columnProperties: ColumnProperty[] = useMemo(
    () =>
      _.map(columns, (c) => ({
        title: c.title,
        sortable: !!c.sortable,
        field: c.field || "",
      })),
    [columns]
  );

  return (

    <>
      {CustomTableRowChild && rows && rows.length > 0 && show && (
        <tr>
          <td
            className="p-0 border-l border-r border-slate-200 bg-amber-50"
            colSpan={(parentColumnsCount ?? columns.length) + 1}
            
          >
            <div className="flex items-start ml-6 mr-4 my-4 ">
              <svg className="w-6 h-6 text-slate-400 mt-2 mr-2 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 3v8h0" />
                <path d="M3 11c0 0 0 5 5 5h13" />
                <path d="M17 12l4 4-4 4" />
              </svg>
              <div className="border border-slate-200 flex-1">
              {childTableTitle && (
                <div className="px-4 py-2 text-sm font-semibold text-slate-700 bg-zinc-100 border-b border-slate-200">
                  {childTableTitle}
                </div>
              )}
              <table
                cellPadding={0}
                cellSpacing={0}
                className="min-w-full whitespace-nowrap p-0 "
              >
                <TableHeader
                  columnProperties={columnProperties}
                  selectableItems={false}
                  rowCount={rows.length}
                  numSelected={0}
                  onSelectAllClick={(e) => e}
                  showSelectAll={false}
                  isChildTable={true}
                  
                />
                <tbody>
                  {rows &&
                    rows.map((childRow: any, index: number) => (
                      <CustomTableRowChild
                        row={childRow}
                        onRowClick={onRowClick}
                        index={index}
                        key={index}
                      />
                    ))}
                </tbody>
              </table>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};
export default TableRowChild;
